import { render, staticRenderFns } from "./account-provider.vue?vue&type=template&id=35b65373&scoped=true&"
import script from "./account-provider.vue?vue&type=script&lang=js&"
export * from "./account-provider.vue?vue&type=script&lang=js&"
import style0 from "./account-provider.vue?vue&type=style&index=0&id=35b65373&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b65373",
  null
  
)

export default component.exports